import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './App.css';
import './fonts/Montserrat-Variable.ttf';
import Map from './frontend/components/agencies/agencies';
import OpenVoucherConfirmacion from './frontend/components/vouchers/confimation/index';
import TemplateSelector from './frontend/layout/TemplateSelector';
import routes from './frontend/routes';
import { GlobalProvider } from 'frontend/contexts/GlobalContext';
import { withSessionStorageCheck } from './frontend/helpers/withSessionStorageCheck';
import ErrorBoundary from './frontend/components/ErrorBoundary/ErrorBoundary';
import { useAppData } from './frontend/hooks/useSafeState';

function App() {
  const { appName } = useAppData();

  return (
    <ErrorBoundary>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{appName}</title>
      </Helmet>
      <Switch>
        <Route path="/open-voucher/confirmacion-iframe" component={OpenVoucherConfirmacion} />
        <Route path="/agencies-iframe" component={Map} />
        <GlobalProvider>
          <TemplateSelector>
            {routes.map((route, i) => (
              <Route key={`${route.path}${route.name}${i}`} {...route} />
            ))}
          </TemplateSelector>
        </GlobalProvider>
      </Switch>
    </ErrorBoundary>
  );
}

export default withSessionStorageCheck(App);
